import { JSX, createMemo } from 'solid-js';

import { cx } from '../utils';

/** Loading组件 */
function Loading(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  const haveColor = createMemo(() => props.class?.includes('text-') || props.class?.includes('fill-'));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
      class={cx('loading', haveColor() && 'text-brand', props.class)}
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
}

export default Loading;

export function BarLoading(props: { class?: string }) {
  return (
    <div class={cx('w-fit center mx-auto', props.class)}>
      <style>{`
        @keyframes slideLeftRight {
          0%, 100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(2.875rem);
          }
        }
        .bar-animate {
          animation: slideLeftRight 1s infinite ease-in-out;
        }
      `}</style>
      <div class={cx('w-[3.75rem] h-2 p-[0.06rem] rounded-[1.3125rem] bg-alpha-bw-autowhite-a5')}>
        <div class="bar w-[0.875rem] h-[0.375rem] rounded-[0.9375rem] bg-alpha-load_color-thumb bar-animate"></div>
      </div>
    </div>
  );
}
